import { CMP_CDID } from "./constants";

window.__cmp =
  window.__cmp ||
  function () {
    (window.__cmp.a = window.__cmp.a || []).push(arguments);
  };
window.__tcfapi =
  window.__tcfapi ||
  function () {
    (window.__tcfapi.a = window.__tcfapi.a || []).push(arguments);
  };
window.__gpp =
  window.__gpp ||
  function () {
    (window.__gpp.a = window.__gpp.a || []).push(arguments);
  };

if (!document.querySelector(`script[data-cmp-ab][data-cmp-cdid="${CMP_CDID}"]`)) {
  const s = document.createElement("script");
  s.src = `https://cdn.consentmanager.net/delivery/autoblocking/${CMP_CDID}.js`;
  s.dataset.cmpAb = "1";
  s.dataset.cmpCdid = CMP_CDID;
  s.dataset.cmpHost = "delivery.consentmanager.net";
  s.dataset.cmpCdn = "cdn.consentmanager.net";
  (document.head ?? document.documentElement).appendChild(s);
}
